/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SetAIToolDecisionRequestBody,
  SetAIToolDecisionRequestBody$Outbound,
  SetAIToolDecisionRequestBody$outboundSchema,
} from "../components/setaitooldecisionrequestbody.js";

export type SetAIToolDecisionSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type SetAIToolDecisionRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  setAIToolDecisionRequestBody: SetAIToolDecisionRequestBody;
};

/** @internal */
export type SetAIToolDecisionSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const SetAIToolDecisionSecurity$outboundSchema: z.ZodMiniType<
  SetAIToolDecisionSecurity$Outbound,
  SetAIToolDecisionSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function setAIToolDecisionSecurityToJSON(
  setAIToolDecisionSecurity: SetAIToolDecisionSecurity,
): string {
  return JSON.stringify(
    SetAIToolDecisionSecurity$outboundSchema.parse(setAIToolDecisionSecurity),
  );
}

/** @internal */
export type SetAIToolDecisionRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  SetAIToolDecisionRequestBody: SetAIToolDecisionRequestBody$Outbound;
};

/** @internal */
export const SetAIToolDecisionRequest$outboundSchema: z.ZodMiniType<
  SetAIToolDecisionRequest$Outbound,
  SetAIToolDecisionRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    setAIToolDecisionRequestBody: SetAIToolDecisionRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      setAIToolDecisionRequestBody: "SetAIToolDecisionRequestBody",
    });
  }),
);

export function setAIToolDecisionRequestToJSON(
  setAIToolDecisionRequest: SetAIToolDecisionRequest,
): string {
  return JSON.stringify(
    SetAIToolDecisionRequest$outboundSchema.parse(setAIToolDecisionRequest),
  );
}
